import api from '../lib/api';
import { IProxy } from '@tool-no-hu/shared/types';


export async function getProxiesService(): Promise<IProxy[]> {
  try {
    const url = '/api/v1/proxies';
    const response = await api.get(url);
    if (response.data && response.data.code === 200) {
      return response.data.data?.proxies || [];
    }
    return [];
  } catch (error) {
    console.error('Failed to get proxies:', error);
    return [];
  }
}

export interface ProxiesPaginatedResult {
  items: IProxy[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export async function getProxiesPaginatedService(
  page: number = 1,
  limit: number = 10,
  search?: string,
): Promise<ProxiesPaginatedResult> {
  try {
    const params: Record<string, any> = { page, limit };
    if (search) params.search = search;
    const response = await api.get('/api/v1/proxies', { params });
    if (response.data && response.data.code === 200) {
      const d = response.data.data;
      return {
        items: d.proxies || [],
        total: d.total || 0,
        page: d.page || page,
        limit: d.limit || limit,
        totalPages: d.totalPages || 0,
      };
    }
    return { items: [], total: 0, page, limit, totalPages: 0 };
  } catch (error) {
    console.error('Failed to get paginated proxies:', error);
    return { items: [], total: 0, page, limit, totalPages: 0 };
  }
}

export async function checkProxyHealthService(value: string): Promise<boolean> {
  try {
    const response = await api.post('/api/v1/proxies/check-health', { values: [value] });
    if (response.data && response.data.code === 200) {
      const results = response.data.data?.results;
      if (Array.isArray(results) && results.length > 0) {
        return !!results[0]?.alive;
      }
    }
    return false;
  } catch (error) {
    console.error('Failed to check proxy health:', error);
    return false;
  }
}

export async function checkMultipleProxiesHealthService(
  values: string[]
): Promise<{ value: string; alive: boolean }[]> {
  try {
    const response = await api.post('/api/v1/proxies/check-health', { values });
    if (response.data && response.data.code === 200) {
      return response.data.data?.results || [];
    }
    return [];
  } catch (error) {
    console.error('Failed to check multiple proxies health:', error);
    return [];
  }
}

export async function createProxyService(value: string): Promise<IProxy | null> {
  try {
    const response = await api.post('/api/v1/proxies', { value });
    if (response.data && (response.data.code === 201 || response.data.code === 200)) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Failed to create proxy:', error);
    return null;
  }
}

export async function updateProxyService(id: string, value: string): Promise<IProxy | null> {
  try {
    const response = await api.put(`/api/v1/proxies/${id}`, { value });
    if (response.data && response.data.code === 200) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Failed to update proxy:', error);
    return null;
  }
}

export async function createManyProxiesService(values: string[]): Promise<IProxy[]> {
  try {
    const response = await api.post('/api/v1/proxies/bulk', { values });
    if (response.data && (response.data.code === 201 || response.data.code === 200)) {
      return response.data.data?.proxies || [];
    }
    return [];
  } catch (error) {
    console.error('Failed to bulk create proxies:', error);
    return [];
  }
}

export async function deleteProxyService(id: string): Promise<boolean> {
  try {
    const response = await api.delete(`/api/v1/proxies/${id}`);
    if (response.data && response.data.code === 200) {
      return true;
    }
    return false;
  } catch (error) {
    console.error('Failed to delete proxy:', error);
    return false;
  }
}
